import './LuckyWheel.less';

import React, { useEffect } from 'react';
import { Button } from '../button/Button';
import i18n from '../../common/i18n';
import imgConfirmDialog from './images/lucky-wheel-info-icon.png';
import clsx from 'clsx';
import { dispatch, useReframe } from 'nike-re-framejs';
import { clearError, showLuckyWheelError } from './h&s';
import CloseIcon from '../../icons/CloseIcon';

const LuckyWheelConfirm = ({ title, subTitle, confirmBonus, rejectBonus, portal = false, closeDialog }) => {
    const { subscribe } = useReframe();
    const error = subscribe(showLuckyWheelError);

    useEffect(() => () => dispatch(clearError), []);

    return (
        <div
            className={clsx('lucky-wheel-confirm flex flex-col', { mobile: !portal })}
            style={portal ? { minHeight: '618px' } : null}
        >
            <CloseIcon onClick={() => closeDialog()} />
            <div className="image">
                <img src={imgConfirmDialog} alt="Lucky Wheel Confirm" />
            </div>
            <div className="content">
                <h1 className="fs-24 uppercase mb-10  mt-50 text-extra-bold">{title}</h1>
                <h2 className="text-normal  mb-20 fs-16">{error ? i18n(`nui.lucky-wheel.${error}`) : subTitle}</h2>
                <div className="button-row">
                    {error ? (
                        <Button
                            large
                            onClick={() => {
                                closeDialog();
                                dispatch(clearError);
                            }}
                            label={i18n('nui.button.close')}
                            dataAtid="lucky-wheel-confirm-dialog-reject"
                            className="nui-button-130 red mr-10"
                        />
                    ) : (
                        <>
                            <Button
                                large
                                onClick={rejectBonus}
                                label={i18n('nui.bonus.zamietnutBonus')}
                                dataAtid="lucky-wheel-confirm-dialog-reject"
                                className="nui-button-130 red mr-10"
                            />
                            <Button
                                primary
                                large
                                onClick={confirmBonus}
                                label={i18n('nui.bonus.confirm')}
                                dataAtid="lucky-wheel-confirm-dialog-confirm"
                                className="nui-button-130  ml-10"
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LuckyWheelConfirm;
